import React from "react";
import { Col, Card } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import DonorDeferralReasonsChart from "./DonorDeferralReasonsChart";

// Static data for donor deferral reasons
const STATIC_DEFERRAL_DATA = {
  reasons: ["Low Hb", "Illness", "Recent Donation", "Medication", "Other"],
  counts: [320, 185, 150, 95, 75],
};

const DonorDeferralReasonsWrapper = () => {
  const { t } = useTranslation();

  return (
    <Col xl={6} lg={6}>
      <Card>
        <Card.Header>
          <Card.Title>{t("Donor Deferral Reasons")}</Card.Title>
        </Card.Header>
        <Card.Body>
          <DonorDeferralReasonsChart data={STATIC_DEFERRAL_DATA} />
        </Card.Body>
      </Card>
    </Col>
  );
};

export default DonorDeferralReasonsWrapper;
